<div id="gameCanvas" class="game-canvas inner">

  <div class="game-frame">
    <!--<div class="demo-mode">You are playing {{ auth.isMainServer() ? 'EDG' : 'DEMO' }} mode</div>-->

    <div *ngIf="!playerService.isRealMoney()" class="demo-mode" [class.none]="hiddenModeDisplay">You are playing DEMO mode</div>

    <app-game-statistics-2></app-game-statistics-2>
    <router-outlet></router-outlet>
  </div>

  <div class="canvas-controls" [ngClass]="{'fullscreen': isFullscreen}">
    <div class="settings">
      <a class="settings-icon" (click)="this.toggleStats()">
        <i class="far fa-chart-bar"></i>
        <span class="popover">
          <span class="title">Stats {{ this.statsOn ? 'on' : 'off' }}</span>
        </span>
      </a>
      <a class="settings-icon" (click)="this.emitRules()" *ngIf="_hasGuide">
        <i class="far fa-{{this.rulesIcon}}"></i>
        <span class="popover">
          <span class="title">Guide</span>
        </span>
      </a>
      <a class="settings-icon" *ngIf="hasBackgroundMusic" (click)="this.toggleMusic()">
        <i class="far fa-{{this.musicIcon}}"></i>
        <span class="popover">
          <span class="title">Music {{ this.musicToggle ? 'on' : 'off' }}</span>
        </span>
      </a>
      <a class="settings-icon" (click)="this.toggleSound()">
        <i class="far fa-{{this.soundIcon}}"></i>
        <span class="popover">
          <span class="title">Sounds {{ !this.soundsOn ? 'on' : 'off' }}</span>
        </span>
      </a>
      <a class="settings-icon" (click)="this.openFairness()">
        <i class="far fa-handshake-alt"></i>
        <span class="popover">
          <span class="title">Fairness</span>
        </span>
      </a>
<!--      <span class="settings-icon" (click)="chipValue = !chipValue" [class.open]="chipValue" *ngIf="_chipValueEnabled">-->
<!--        <i class="far fa-coins"></i>-->
<!--        <span class="popover">-->
<!--          <span class="title">Chip value</span>-->
<!--          <span class="options">-->
<!--            <a (click)="setMultiplier(3, $event)" [class.active]="multiplier === 3">High stakes</a>-->
<!--            <a (click)="setMultiplier(2, $event)" [class.active]="multiplier === 2">Medium stakes</a>-->
<!--            <a (click)="setMultiplier(1, $event)" [class.active]="multiplier === 1">Low stakes</a>-->
<!--          </span>-->
<!--        </span>-->
<!--      </span>-->
<!--      <span class="settings-icon w-auto" (click)="decimal = !decimal" *ngIf="currency !== 'EDG' && _chipDecimalEnabled" [class.open]="decimal">-->
<!--        <span class="text-value">{{ getCurrencyLabel() }}</span>-->
<!--        <span class="popover">-->
<!--          <span class="title">Chip decimal</span>-->
<!--           <span class="options">-->
<!--            <a (click)="setMicro(true, $event)" [class.active]="micro">m{{ currency }}</a>-->
<!--            <a (click)="setMicro(false, $event)" [class.active]="!micro">{{ currency }}</a>-->
<!--          </span>-->
<!--        </span>-->
<!--      </span>-->
      <!--<a class="settings-icon" (click)="this.toggleFullscreen()">-->
        <!--<i class="fal fa-{{this.fullscreenIcon}}"></i>-->
      <!--</a>-->
    </div>

    <div class="game-message" [ngClass]="infoClass">{{ infoBar }}</div>

    <div class="game-totals">
      <div class="balance-wrap">
        <div class="balance-current">
          <div class="currency-image" [ngClass]="playerService.getCurrency()"></div>
          <span class="nav-balance">{{ playerService.getBalance() | crypto: playerService.getCurrency() : true : true : true }}</span>
          <span class="currency" [ngClass]="playerService.getCurrency()">{{ getCurrencyLabel() }}</span>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/games/game-canvas/game-canvas.component.html